import { render, staticRenderFns } from "./swiper.vue?vue&type=template&id=75c881fe&scoped=true&"
import script from "./swiper.vue?vue&type=script&lang=ts&"
export * from "./swiper.vue?vue&type=script&lang=ts&"
import style0 from "./swiper.vue?vue&type=style&index=0&id=75c881fe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75c881fe",
  null
  
)

export default component.exports